import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {withTranslation} from 'react-i18next';
import _ from 'lodash';
import { TypeAhead } from '../../shared/TypeAhead';
import { colors } from '../../../shared/styles';
import {Link} from 'react-router-dom';

const TypeaheadOption = ({option, isFocused, isHovered, t}) => {
  //in the future, can bold out portion of option that matches typed value

  //weirdly the key is needed to rerender from bold to non-bold font

  return (
    <Link to={`/race/create/${option.MasterID}`} className={'race-name-dropdown'}>
      <div key={'option_'+(isFocused?1:0)}
          style={{cursor: 'pointer',
                    padding:'5px',
                    borderRadius: '5px',
                    textAlign:'left',
                    backgroundColor: isFocused? colors.blue : isHovered ? 'lightgrey':  'white',
                    borderBottom:'1px solid lightgrey',
                    color: isFocused?'white':'black'}}>
        {option.MasterName}
        <div style={{color: isFocused?'white':'#919191',fontSize:'13px'}}>
          <br />
          {t('{{city}}, {{stateProvAbbrev}}', {city: option.City, stateProvAbbrev: option.StateProvAbbrev})}
        </div>
      </div>
    </Link>
  );
};

class RaceNameInputComponent extends Component {
  static propTypes = {
    fetchRacesTypeAhead: PropTypes.func.isRequired,
    redirectToNewCreatePage: PropTypes.func.isRequired,
    name: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onOptionPicked: PropTypes.func.isRequired,

    showRequired: PropTypes.bool.isRequired,
    disabled: PropTypes.bool.isRequired,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    t: PropTypes.func
  };

  static defaultProps = {
    width: 300
  };

  constructor(props) {
    super(props);

    this.state = {
      fetching: false,
      error: null,
      fetched: undefined
    };

    this.debouncedFetch = _.debounce(this.fetch, 800);
  }

  componentWillUnmount() {
    this.unmounted = true;
    this.debouncedFetch.cancel();
  }

  render() {
    const {
      fetched = []
    } = this.state;

    const {
      name = '',
      showRequired,
      width,
      t
    } = this.props;

    return (
      <div>

        <div style={{display:'inline-block', width:'100%'}}>
          <TypeAhead
            useMaterialUi={true}
            value={name}
            label={t('Race Name')}
            errorText={!name && showRequired ? t('Name is required') : ''}
            dropdownHeight={300}
            dropdownTop={63}
            width={width}
            options={fetched}
            dropdownStyle={{border: '1px solid lightgrey', borderRadius: 5, boxShadow: '0 0 9px 5px rgba(0,0,0,.05)', backgroundColor:'white'}}
            renderOption={TypeaheadOption}
            onChange={this.onTyped}
            onOptionSelected={this.onOptionSelected}
            />
        </div>

      </div>
    );
  }

  //text was typed into input
  onTyped = (e) => {
    this.props.onChange(e.target.value);

    //update dropdown typeahead/autosuggest options
    this.debouncedFetch(e.target.value);
  };

  //clicked on an option or keyed Enter on a focused option
  onOptionSelected = (option) => {
    this.props.onOptionPicked(option);
  };

  fetch = (term) => {
    const { fetchRacesTypeAhead } = this.props;

    if (term) {
      this.setState({
        fetching: true,
        error: null
      }, () => {
        fetchRacesTypeAhead(term)
          .then((fetched) => {
              if (this.unmounted) return;

              this.setState({
                fetching: false,
                fetched
              });
            },
            (error) => {
              if (this.unmounted) return;

              this.setState({
                fetching: false,
                error
              });
            });
      });
    }
  }
}

export const RaceNameInput = withTranslation()(RaceNameInputComponent);



/** WEBPACK FOOTER **
 ** ./components/race/create/RaceNameInput.js
 **/